import { PurchasedItem } from "@scrile/api-provider/dist/api/PurchasedItemsProvider";
import { getContextModules, getComponent } from "@/lib/requireContextHelpers";
import MediaPostView from "./MediaPostView.vue";

const modules = getContextModules(require.context("./views/", true, /\.\/[a-zA-Z]*View\/index.ts/));

export default function(item: PurchasedItem) {
  return getComponent(modules, item, MediaPostView);
}
